/**
 * What to show for a source or a message in a table cell. Every e-mail that comes through SES carries a click-tracking
 * URL in brackets at the end, which is the same noise on every row and pushed the real text into four wrapped lines.
 * The full string is still one click away in the source information modal.
 */
export const displaySource = (source?: string): string => (source || '').replace(/\s*\[https?:\/\/\S*\]?\s*$/, '').trim() || source || '';
